import fetchGroupOutcomes from './fetchGroupOutcomes';

export default function fetchGroupAssistanceRequestOutcomes(groupId, serviceTypeId, params = {}) {
  return fetchGroupOutcomes(groupId, serviceTypeId, {
    applicable_states: ['assistance_requested'],
    ...params,
  });
}
